export default "__VITE_ASSET__BXOmrkIJ__"